export default {
    departamentos: [],
    departamento: {}
}